module.exports = __webpack_public_path__ + "img/brush.42afd232.svg";